module.exports = __webpack_public_path__ + "img/logo3.6075af7d.png";